<template>
    <el-main>
  
     
  id:{{ xm_id }}  项目:{{ xm }}

  <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 600px;">
    <el-tab-pane label="总成绩管理" name="first">
      <div class="row">
    <div class="col-3">
       科目对应列表
      <a-select :value="selkemu" style="width: 100%" @change="handleChangeSelkemu">
          <a-select-option v-for="i in kemulist" :key="i.index">
            {{ i.kemu }}
          </a-select-option>
      </a-select>
    </div>
  </div>

    <vxe-table
      border
      height="460"
      :data="onekemulist">
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-column field="yuming" title="服务器"></vxe-column>
      <vxe-column field="xm" title="项目"></vxe-column>
      <vxe-column field="kemu" title="科目"></vxe-column>
    
    </vxe-table>


      <el-button @click="handlehbscore"   type="primary" icon="el-icon-edit">合并总成绩</el-button>  
      <el-button @click="zongfenprocess"   type="primary" icon="el-icon-edit">总成绩汇总+生成xls</el-button>  
    </el-tab-pane>
    <el-tab-pane label="单科成绩管理" name="second">
     
      <el-button @click="handlehbdkscore"   type="primary" icon="el-icon-edit">合并单科成绩</el-button>
      <el-button @click="dankeprocess"   type="primary" icon="el-icon-edit">单科汇总+生成xls</el-button> 
    </el-tab-pane>
    <el-tab-pane label="上线分数设置计算" name="third">
      

        <vxe-button icon="vxe-icon-goods" @click="cankaoschoollist">参考学校列表</vxe-button> 
        项目类型:{{ xmtype }}
        <vxe-radio-group v-model="val1" @change="radiochange">
          <vxe-radio label="1" :content="xmtype1"></vxe-radio>
          <vxe-radio label="2" :content="xmtype2"></vxe-radio> 
        </vxe-radio-group>

          <vxe-table
                border
                show-overflow
                keep-source
                show-footer
                ref="xTable"
                max-height="400"
                :data="schoolist"
                :footer-method="footerMethod"
                :edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit', showStatus: true}">
            
                <vxe-column type="seq" width="60"></vxe-column>
                <vxe-column field="school" title="学校" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.school" type="text"></vxe-input>
                  </template>
                </vxe-column>

                <vxe-column field="sx1" title="1上线人数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.sx1" type="text"></vxe-input>
                  </template>
                </vxe-column>

                <vxe-column field="sx2" title="2上线人数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.sx2" type="text"></vxe-input>
                  </template>
                </vxe-column>

                <vxe-column field="sx3" title="3上线人数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.sx3" type="text"></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column field="sx4" title="4上线人数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.sx4" type="text"></vxe-input>
                  </template>
                </vxe-column>

                <vxe-column field="sx5" title="5上线人数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.sx5" type="text"></vxe-input>
                  </template>
                </vxe-column>

                <vxe-column field="sx6" title="6上线人数" sortable :edit-render="{autofocus: '.vxe-input--inner', defaultValue: ''}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.sx6" type="text"></vxe-input>
                  </template>
                </vxe-column>
                
          </vxe-table>        

          <vxe-toolbar>
            <template #buttons>                    
              <vxe-button icon="vxe-icon-save" @click="saveschoolsx">保存上线人数</vxe-button>
              <vxe-button icon="vxe-icon-merge-cells" @click="calcsxcanshu">计算上线分数</vxe-button>
              <vxe-button icon="vxe-icon-feedback" @click="shangxiantable">查看上线分数</vxe-button>
            </template>
          </vxe-toolbar>
         
    </el-tab-pane>
    <el-tab-pane label="上线分数和报表" name="fourth">
     项目类型:{{ xmtype }}
        <vxe-radio-group v-model="val1" @change="radiochange">
          <vxe-radio label="1" :content="xmtype1"></vxe-radio>
          <vxe-radio label="2" :content="xmtype2"></vxe-radio> 
        </vxe-radio-group>
      <vxe-table
          border="inner"
          keep-source
          highlight-hover-row
          highlight-current-row
          ref="xTablebbbb"
          height="300"
          :data="sxtableData"
          :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}">
          <vxe-column field="sxname" title="上线名称" width="120" sortable :edit-render="{name: '$input', props: {type: 'text'}}">
                <template #edit="{ row }">
                  <vxe-input v-model="row.sxname" type="text"></vxe-input>
                </template>
              </vxe-column>
          <vxe-column
              v-for="config in tableColumn"
              :key="config.key"
              :type="config.type"
              :field="config.field"
              :title="config.title"
              :fixed="config.fixed"
              :width="config.width"
              :filters="config.filters"
              :edit-render="{name: '$input', props: {type: 'number'}}">
            </vxe-column>
        </vxe-table>
        <vxe-button icon="vxe-icon-save" @click="shangxiandatasave">保存上线数据</vxe-button>
    </el-tab-pane>
    <el-tab-pane label="报表管理" name="fifth">
      <vxe-button icon="vxe-icon-save" @click="createsxl">生成上线excel</vxe-button>
      <vxe-button icon="vxe-icon-save" @click="createsxlpdf">测试pdf</vxe-button>
      <vxe-button icon="vxe-icon-save" @click="downpdf">下载pdf</vxe-button>
   </el-tab-pane>
  </el-tabs>
   
    </el-main>
    
  
  </template>
  <script>
  import axios from 'axios'
  import qs from 'qs'
  import localStorage from 'localStorage'
  import XEUtils from 'xe-utils'
  import VXETable from 'vxe-table'  
  import FileSaver from 'file-saver'
 

  export default {

    data() {
      
      return {

        selkemu:'',
        kemulist:[],
        allxmkemulist:[],
        dykemulist:[],
        onekemulist:[],
        xmtype:'不分科',
        val1:'1',
        xmtype1:'理科',
        xmtype2:'文科',
        
         activeName: 'second',
        
                img_src:'',
            fit:'contain',
            schoolist:[],
            scannerList: [],
            singleTizuData:[],
            currentRow: null,
            status:false,
            add_svr_name: '',
            add_svr_yuming: '',
            title:'hello world',
            schoolList:[],
            selSchool:'',
            selClass:'',
            editableTabs: [
              {
                  title: 'Tab 1',
                  name: '1',
                  content: 'Tab 1 content'
              }, 
              {
                    title: 'Tab 2',
                    name: '2',
                    content: 'Tab 2 content'
              }
              ],
              sel_svr:'',
              sel_svr_yuming:'',
              sel_xm:'',
              sel_sb:'',
              dialogTableVisible: false,
              is_disable:true,
              is_jindu_disable:true,
              options:[],
              cascagerdefault: ["0", "0"],
              tableData: [],
              sxtableData: [],
              kemucount:0,
              tableColumn: [ ] ,
              loading: false,
              duizhaoData:[],
              studentcount:0,
              innamelist:false,
              notincludezero:false,
              xm_id:'',
              xm:'',
              columns: [
                  {title: '姓名', field: 'name'},
                  {title: '年龄', field: 'age'},
                  {title: '性别', field: 'gender'}
                ],
                tableDatax: [
                  {name: '张三', age: 18, gender: '男'},
                  {name: '李四', age: 20, gender: '女'},
                  {name: '王五', age: 22, gender: '男'}
                ],
           
              
           };
    },
     activated() {
            
  
        this.scannerList=[];

        this.xm_id=localStorage.getItem('xm_id')
        this.xm=localStorage.getItem('xm')  
        
  
      },

    methods: {
      openAlert (options) {
      VXETable.modal.alert(options)
    },

      handleClick(tab, event) {
        console.log(this.activeName);
        console.log(tab, event);
        
        if (this.activeName=='first')
        {
          this.allxmkemu();
        }
        
        if (this.activeName=='third')
        {
          this.cankaoschoollist();
        }

        if (this.activeName=='fourth')
        {
          this.shangxiandata();
        }
      },
      sumNum (list, field) {
              let count = 0
              list.forEach(item => {
                count += Number(item[field])
              })
              return count
            },
      footerMethod ({ columns, data }) {
              return [
            
                columns.map((column, columnIndex) => {
                  if (columnIndex === 0) {
                    return '总数'
                  }
                  if (['sx1', 'sx2', 'sx3', 'sx4', 'sx5', 'sx6'].includes(column.property)) {
                    return this.sumNum(data, column.property)
                  }
                  return null
                })
              ]
            },

      handlehbscore () {              
            console.log('合并成绩')             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'hebing',"dykemulist":JSON.stringify(this.dykemulist)})).then((res)=>{
              console.log(res)
              this.filter=null;
              this.fields=res.data.kemu;
              this.items=res.data.score;
              this.tmpitems=this.items
              this.totalRows = this.items.length;

              this.classList=res.data.class;
              let nuv={ value: null, text: '请选择班级' };
              this.classList.unshift(nuv);

              if (this.classList.length>=1)
              {
                this.isshow=true;
              }
              console.log(res.data.class);
              this.loading=false
              
          }).catch((res)=>{
              console.log(response)
          })

     },

     handlehbdkscore()
     {
      console.log('合并单科成绩')             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'hbdankescore',"dykemulist":JSON.stringify(this.dykemulist)})).then((res)=>{
              console.log(res)
          
              
          }).catch((res)=>{
              console.log(response)
          })
     },

     zongfenprocess () {              
            console.log('合并成绩zongfenprocess')             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'zongfenprocess'})).then((res)=>{
              console.log(res)
              this.filter=null;
              this.fields=res.data.kemu;
              this.items=res.data.score;
              this.tmpitems=this.items
              this.totalRows = this.items.length;

              this.classList=res.data.class;
              let nuv={ value: null, text: '请选择班级' };
              this.classList.unshift(nuv);

              if (this.classList.length>=1)
              {
                this.isshow=true;
              }
              console.log(res.data.class);
              this.loading=false
              
          }).catch((res)=>{
              console.log(response)
          })

     },
     dankeprocess () {              
            console.log('合并成绩dankeprocess')             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'dankeprocess',"dykemulist":JSON.stringify(this.dykemulist)})).then((res)=>{
              console.log(res)
              this.filter=null;
              this.fields=res.data.kemu;
              this.items=res.data.score;
              this.tmpitems=this.items
              this.totalRows = this.items.length;

              this.classList=res.data.class;
              let nuv={ value: null, text: '请选择班级' };
              this.classList.unshift(nuv);

              if (this.classList.length>=1)
              {
                this.isshow=true;
              }
              console.log(res.data.class);
              this.loading=false
              
          }).catch((res)=>{
              console.log(response)
          })

     },

     allxmkemu() {              
            console.log('exmanallxmkemu')             
            axios.post('/scoreman?op=exmanallxmkemu',qs.stringify({"xm_id":this.xm_id})).then((res)=>{
 
            console.log(res.data)       
            this.allxmkemulist= res.data['allkemu']
            this.kemulist= res.data['kemulist'] 
            
           
            this.dykemulist=res.data['dykemulist']

            this.selkemu=res.data['kemulist'][0]['kemu']
            this.onekemulist=res.data['dykemulist'][0]['data']
            //项目类型
            this.xmtype=res.data['xmtype']
            if (this.xmtype=='文理科'){
                this.xmtype1="理科"
                this.xmtype2="文科"
            }

            if (this.xmtype=='新高考'){
                this.xmtype1="物理类"
                this.xmtype2="历史类"
            }

               
              
          }).catch((res)=>{
              console.log(response)
          })

     },

     radiochange(){

      console.log('radiochange')
      console.log(this.val1)

      if (this.xmtype=='文理科'){
                 
        }

      if (this.xmtype=='新高考'){
          
      }

      

      if (this.activeName=='third'){

          this.cankaoschoollist()
      }

      if (this.activeName=='fourth'){

          this.shangxiandata()
      }

   
     },
     getkebie(){
            let kebie='不分科' 
            if (this.xmtype=='文理科'){
                 if (this.val1=='1'){
                  kebie='理科'
                 }
                 else{
                  kebie='文科'
                 }
                }
        
              if (this.xmtype=='新高考'){
                if (this.val1=='1'){
                  kebie='物理类'
                 }
                 else{
                  kebie='历史类'
                 }
              }
              return kebie
     },
     cankaoschoollist () {              
            console.log('cankaoschoollist')       

            let kebie=this.getkebie()

            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'cankaoschoollist','kebie':kebie})).then((res)=>{
              console.log(res)
              this.filter=null
              this.schoolist=res.data.slist
    
              this.loading=false

               
              
          }).catch((res)=>{
              console.log(response)
          })

     },

     saveschoolsx () {              
            console.log('saveschoolsx')   
            let kebie=this.getkebie()
            const $table = this.$refs.xTable
            const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()     
            const body = { insertRecords, removeRecords, updateRecords }
                      
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'saveschoolsx','kebie':kebie,"scsxdata":JSON.stringify(body)})).then((res)=>{
              console.log(res)
               this.openAlert({ content: res.data, title: '提示' });
               this.cankaoschoollist();
              
          }).catch((res)=>{
              console.log(response)
          })

     },

     //成功后 按照类型 返回结果  也可以按照类型 修改对应分值   
     calcsxcanshu () {              
            console.log('calcsxcanshu')  

            let kebie=this.getkebie()
             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'calcsxcanshu','kebie':kebie})).then((res)=>{
             // console.log(res)
             this.openAlert({ content: res.data, title: '提示' });
               
              
          }).catch((res)=>{
              console.log(response)
          })

     },

     shangxiantable () {              
            this.$router.push({ path: '/scorexsxfen'});	

     },
     createsxl () {              
            console.log('createsxl')   
            let kebie=this.getkebie()
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'createsxl','kebie':kebie})).then((res)=>{
             // console.log(res)        
             this.openAlert({ content: res.data, title: '提示' });       
              
          }).catch((res)=>{
              console.log(response)
          })

     },
     createsxlpdf () {              
            console.log('createsxlpdf')                
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'py_op':'createsxlpdf'})).then((res)=>{
             // console.log(res)        
             this.openAlert({ content: res.data, title: '提示' });       
              
          }).catch((res)=>{
              console.log(response)
          })

     },
     downpdf () {   

            console.log('downpdf')   
             
            axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'py_op':'downpdf'}),{responseType: 'blob'})
            .then((res)=>{
              const { data, headers } = res
          
              let fileName
                if (headers['content-disposition']) {
                  console.log('aa')
                  console.log(headers['content-disposition'])
                    fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
                } else {
                  console.log(data)
                  console.log('bb')
                    fileName = data.fileName
                }

                fileName=this.xm_id+'.pdf'

              console.log(fileName)
              // 此处当返回json文件时需要先对data进行JSON.stringify处理，其他类型文件不用做处理
              //const blob = new Blob([JSON.stringify(data)], ...)
              const blob = new Blob([data], {type: headers['content-type']})           
              
              FileSaver.saveAs(blob, fileName);
              
              /*
              const filename = decodeURI(fileName)
              console.log(fileName)
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = filename
                link.click()
                window.URL.revokeObjectURL(url)
                */
              
          }).catch((res)=>{
              console.log(response)
          })

     },
     shangxiandatasave () {              
         
         let updateRecordsx = this.$refs.xTablebbbb.getUpdateRecords()
           console.log(updateRecordsx)

         console.log('shangxiandatasave')   
         let kebie=this.getkebie()
         
           const $table = this.$refs.xTablebbbb
           const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()     
           const body = { insertRecords, removeRecords, updateRecords }
                     
           axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'shangxiandatasave','kebie':kebie,'kemucount':this.kemucount,"scsxdata":JSON.stringify(body)})).then((res)=>{
            
            this.openAlert({ content: res.data, title: '提示' });
             //保存上线数据
             this.shangxiandata();
              
             
         }).catch((res)=>{
             console.log(response)
         })

    },

       shangxiandata () {              
           console.log('shangxiandata')   
           let kebie=this.getkebie()
            
           axios.post('/cjman?op=scorexman',qs.stringify({"xm_id":this.xm_id,'php_op':'shangxiandata','kebie':kebie})).then((res)=>{
             console.log(res)
             this.kemucount=res.data.kemucount
             this.tableColumn=res.data.tableColumn
             this.sxtableData=res.data.tableData
           
              
             
         }).catch((res)=>{
             console.log(response)
         })

    },
 
    handleChangeSelkemu(value) {
      console.log(`selected ${value}`)
      console.log(value.length)
      this.selkemu=value
      
      this.selkemu=this.dykemulist[value]['kemu']
      this.onekemulist=this.dykemulist[value]['data']
    },
  
 
  
    },
  }
  </script>
  
  <style scoped>
  .el-dialog {
       display: flex;
       flex-direction: column;
       margin:0 !important;
       position:absolute;
       top:50%;
       left:50%;
       transform:translate(-50%,-50%);
       /*height:600px;*/
       max-height:calc(100% - 200px);
       max-width:calc(100% - 30px);
  }
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
    }
  .el-dialog .el-dialog__body {
       flex:1;
       overflow: auto;
  }
  
  
  </style>